import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { MedioPagoController } from './medio-pago.controller';
import { MedioPagoService } from './medio-pago.service';

@Module({
  imports: [PrismaModule],
  controllers: [MedioPagoController],
  providers: [MedioPagoService],
  exports: [MedioPagoService],
})
export class MedioPagoModule {}
